import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

/** Matches `Community.styles.ts` `.stats` / `.statsValue` for subscriber count line. */
export const useStyles = makeStyles<Theme>()((theme) => ({
  stats: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    margin: `${theme.spacing(1)} 0`,
    color: theme.palette.text.secondary,
    flexWrap: 'wrap',
  },
  statsList: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    margin: 0,
    marginTop: theme.spacing(0.25),
    color: theme.palette.text.secondary,
    flexWrap: 'wrap',
  },
  statsValue: {
    color: theme.palette.text.primary,
    fontWeight: 700,
  },
}));
